import { useEffect, useState } from "react";
import { useAdminStatus } from "../../hooks/useAdminStatus";
import OnboardingPage from "./OnboardingPage/OnboardingPage";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import LoginPage from "./LoginPage";
import { useNavigate } from "react-router-dom";
import AdminPage from "./AdminPage";

const HomePage = () => {
  const isAdmin = useAdminStatus();
  const [page, setPage] = useState();

  useEffect(() => {
    function getPage() {
      if (isAdmin === null) {
        return (
          <div className="container-fullscreen">
            <div className="loading-spinner"></div>
          </div>
        );
      } else if (isAdmin) {
        return <AdminPage />;
      } else {
        return <OnboardingPage />;
      }
    }
    setPage(getPage);
  }, [isAdmin]);

  return (
    <>
      <AuthenticatedTemplate>{page}</AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <LoginPage></LoginPage>
      </UnauthenticatedTemplate>
    </>
  );
};

export default HomePage;
